import { AfterViewInit, Component } from '@angular/core';
import { MatTableDataSource } from '@angular/material/table';
import { ColumnData, LoadLogSource } from '@ov-suite/helpers-shared';
import { LoadLogModel } from '@ov-suite/models-warehouse';
import { BehaviorSubject } from 'rxjs';
import { LoadManagementDataService } from '../load-management.data.service';

type LogTab = {
  title: string;
  source: LoadLogSource;
  dataSource: MatTableDataSource<LoadLogModel>;
  fetchDownloadData: BehaviorSubject<LoadLogModel[]>;
};

@Component({
  selector: 'ov-suite-log-tab',
  templateUrl: './log-tab.component.html',
  styleUrls: ['./log-tab.component.scss'],
})
export class LogTabComponent implements AfterViewInit {
  formClass = LoadLogModel;

  tabs: LogTab[] = [
    {
      title: 'Web',
      source: LoadLogSource.WEB,
      dataSource: new MatTableDataSource<LoadLogModel>([]),
      fetchDownloadData: new BehaviorSubject<LoadLogModel[]>(null),
    },
    {
      title: 'Mobile',
      source: LoadLogSource.MOBILE,
      dataSource: new MatTableDataSource<LoadLogModel>([]),
      fetchDownloadData: new BehaviorSubject<LoadLogModel[]>(null),
    },
  ];

  columnData: ColumnData<LoadLogModel>[] = [
    {
      title: 'Timestamp',
      type: 'date-time',
      key: 'createDate',
    },
    {
      title: 'Event',
      type: 'string',
      key: 'message',
    },
    {
      title: 'User',
      type: 'deep-string',
      key: 'createdBy.username',
    },
  ];

  constructor(public loadManagementDataService: LoadManagementDataService) {}

  async ngAfterViewInit() {
    await Promise.all(
      this.tabs.map(async tab => {
        tab.dataSource.sortData = this.createSortData();
        tab.dataSource.data = await this.loadManagementDataService.getLogs(tab.source);
      }),
    );
  }

  createSortData() {
    return (data: LoadLogModel[], matSort: { direction: 'asc' | 'desc' | ''; active: string }) => {
      if (matSort.direction) {
        const up = matSort.direction === 'asc' ? 1 : -1;
        switch (matSort.active) {
          case 'Timestamp':
            data.sort((a, b) => (a.createDate > b.createDate ? up : -up));
            break;
          case 'Event':
            data.sort((a, b) => (a.message.toLowerCase() > b.message.toLowerCase() ? up : -up));
            break;
          case 'User':
            data.sort((a, b) => (a.createdBy.username.toLowerCase() > b.createdBy.username.toLowerCase() ? up : -up));
            break;
          default:
        }
      }
      return data;
    };
  }

  async fetchData(tab: LogTab) {
    tab.fetchDownloadData.next(tab.dataSource.data);
  }
}
